import { Component, computed, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StockIncomingItem } from '../../../../pages/admin-dashboard/stock-management/add-all-stock/add-stock.model';
import { ConfirmationDialog } from '../../../../shared/ui/confirmation-dialog/confirmation-dialog';

@Component({
  selector: 'app-stock-temporary-table',
  standalone: true,
  imports: [CommonModule, ConfirmationDialog],
  templateUrl: './stock-temporary-table.html',
    styleUrl: './stock-temporary-table.scss',
})
export class StockTemporaryTable {
  private locale = inject(LOCALE_ID);

  list = input.required<StockIncomingItem[]>();
  onEdit = output<number>();
  onRemove = output<number>();
  onSubmit = output<void>();
  onReset = output<void>();
  isAr = computed(() => this.locale.startsWith('ar'));

  currency = computed(() => (this.isAr() ? 'ج.م' : 'EGP'));
  discountLabel = computed(() => (this.isAr() ? 'خصم' : 'Disc.'));
  mfgLabel = computed(() => (this.isAr() ? 'إنتاج:' : 'MFG:'));
  expLabel = computed(() => (this.isAr() ? 'إنتهاء:' : 'EXP:'));

  showResetDialog = signal(false);
  isArabic = computed(() => this.locale.startsWith('ar'));

  confirmReset() {
    this.onReset.emit();
    this.showResetDialog.set(false);
  }
  isExpired(date: string): boolean {
    return new Date(date) < new Date();
  }

  isNearExpiry(date: string): boolean {
    const expiry = new Date(date);
    const today = new Date();
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(today.getMonth() + 3);
    return expiry > today && expiry <= threeMonthsFromNow;
  }
}
